/**
 * Constantes de marca Vellus — imutáveis entre temas.
 * Não usar diretamente em componentes: prefira os tokens semânticos via CSS custom properties.
 */
export const brand = {
    vellusMarinho: "#1b1d36",
    vellusLagoa: "#369da0",
    vellusBranco: "#ffffff",
};
export const marinhoScale = {
    900: "#0e0f1f",
    800: "#14152a",
    700: "#1b1d36",
    600: "#2a2d4e",
    500: "#3f4374",
    400: "#6b6f9c",
    300: "#9ea1c2",
    200: "#c7c9dd",
    100: "#e5e6ef",
    "050": "#f4f4f9",
};
export const lagoaScale = {
    900: "#133a3b",
    800: "#1f5a5c",
    700: "#2a7e81",
    600: "#369da0",
    500: "#4fb1b4",
    400: "#7ac6c8",
    300: "#a6d9da",
    200: "#cde8e9",
    100: "#e5f2f2",
    "050": "#f2f8f8",
};
export const neutralScale = {
    "000": "#ffffff",
    "050": "#fafafc",
    100: "#f2f2f6",
    200: "#e4e5ec",
    300: "#cacbd6",
    400: "#9698a8",
    500: "#6a6c7e",
    600: "#4a4c5e",
    700: "#2f3145",
    800: "#1f2138",
    900: "#14152a",
};
//# sourceMappingURL=brand.js.map